module.exports = {

  eadmin: {
    baseUrl: '/eadmin2-api',
  },
  edata: {
    baseUrl: '/edata',
  },
  subject: {
    baseUrl: '/subject',
  },
  media: {
    baseUrl: '/media',
  },
  miner: {
    baseUrl: '/miner',
  },
  esocket: {
    baseUrl: '/',
  },
  microdata: {
    baseUrl: '/microdata2',
  },
  elog: {
    baseUrl: '/elog',
  },
  file: {
    baseUrl: '/file',
  },
  utility: {
    baseUrl: '/utility',
  },
};




/*****************
 ** WEBPACK FOOTER
 ** ./config.js
 ** module id = 651
 ** module chunks = 0 5
 **/